import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { getUrlOrigin } from "@/urls";

export const Footer = observer(function Footer() {
  const t = useTranslations();
  return (
    <div className="flex justify-center mt-auto pb-10 px-4">
      <p className="text-gray-500 text-[16px] leading-[20px] font-geist font-normal whitespace-pre text-center tracking-tighter">
        {t.rich("createTeamDialog.notice", {
          tosLink: (chunks) => (
            <a
              href={`${getUrlOrigin()}/tos`}
              target="_blank"
              rel="noreferrer"
              className="text-blue-500"
            >
              {chunks}
            </a>
          ),
          privacyLink: (chunks) => (
            <a
              href={`${getUrlOrigin()}/privacy`}
              target="_blank"
              rel="noreferrer"
              className="text-blue-500"
            >
              {chunks}
            </a>
          ),
        })}
      </p>
    </div>
  );
});
